import { render } from "./EmployeeRequestsPanel.vue?vue&type=template&id=2d518301&scoped=true"
import script from "./EmployeeRequestsPanel.vue?vue&type=script&lang=js"
export * from "./EmployeeRequestsPanel.vue?vue&type=script&lang=js"

import "./EmployeeRequestsPanel.vue?vue&type=style&index=0&id=2d518301&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d518301"]])

export default __exports__